import { COUNTRY_CODES, type CountryCodeEntry } from "../components/ui/country-codes.ts"

export { COUNTRY_CODES }
export type { CountryCodeEntry }

function digitsOf(code: string): string {
  return code.replace(/\D/g, "")
}

function normalizeSearch(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
}

export function findCountryByCode(code: string): CountryCodeEntry {
  return COUNTRY_CODES.find((country) => country.code === code) ?? COUNTRY_CODES[0]
}

export function findCountryByIso(iso: string): CountryCodeEntry {
  return COUNTRY_CODES.find((country) => country.iso === iso) ?? COUNTRY_CODES[0]
}

export function parsePhone(fullPhone: string): { countryCode: string; localPhone: string } {
  const trimmed = fullPhone.trim()
  if (!trimmed) {
    return { countryCode: "+52", localPhone: "" }
  }

  const ranked = [...COUNTRY_CODES].sort((a, b) => b.code.length - a.code.length)
  for (const country of ranked) {
    if (trimmed.startsWith(country.code)) {
      return { countryCode: country.code, localPhone: trimmed.slice(country.code.length).trim() }
    }
  }

  return { countryCode: "+52", localPhone: trimmed.replace(/^\+\d+\s*/, "") }
}

export function formatFullPhone(countryCode: string, localPhone: string): string {
  return `${countryCode}${localPhone.replace(/\s/g, "")}`
}

export function isValidPhone(localPhone: string, countryCode = "+52"): boolean {
  const localDigits = localPhone.replace(/\D/g, "")
  const countryDigits = digitsOf(countryCode)
  const total = countryDigits.length + localDigits.length
  return localDigits.length >= 4 && total >= 8 && total <= 15
}

export function maxLocalDigitsFor(countryCode: string): number {
  return Math.max(4, 15 - digitsOf(countryCode).length)
}

export function filterCountryCodes(query: string): CountryCodeEntry[] {
  const needle = normalizeSearch(query.trim())
  if (!needle) return COUNTRY_CODES
  return COUNTRY_CODES.filter((country) => {
    return (
      normalizeSearch(country.name).includes(needle) ||
      normalizeSearch(country.code).includes(needle) ||
      normalizeSearch(country.iso).includes(needle)
    )
  })
}
